export const getValuesForInfoMessage = ({ extraFee, includedItems, baseExtraFee, currency, language }) => {
  return {
    extraFee: new Intl.NumberFormat(language, {
      style: 'currency',
      currency: currency || 'EUR',
    }).format(extraFee),
    includedItems: includedItems,
    baseExtraFee: new Intl.NumberFormat(language, {
      style: 'currency',
      currency: currency || 'EUR',
    }).format(baseExtraFee),
  }
}
